<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col class="col-12">
                    <ValidationProvider name="status" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('status')">
                            <b-form-select :options="options" v-model="form.status"></b-form-select>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col class="col-12" v-if="form.status === 'approved'">
                    <ValidationProvider name="deliverer_id" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('deliverer')">
                            <staff-auto-complete v-model="form.deliverer_id"
                                                 :validate-error="errors[0]"

                            />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col class="col-12" v-if="form.status === 'declined'">
                    <ValidationProvider name="reason" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('reason_for_rejection')">
                            <b-form-textarea v-model="form.reason"
                                             :class="errors[0] ? 'is-invalid':''"
                                             rows="5"
                            />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <b-button @click="saveForm" :disabled="formLoading" variant="primary">
                {{ $t('save') }}
            </b-button>
        </ValidationObserver>
    </div>
</template>

<script>
    //Component
    import StaffAutoComplete from "@/components/interactive-fields/StaffAutoComplete";

    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import CarReservationService from "@/services/CarReservationService";

    export default {
        props: {
            formId: {
                type: Number
            }
        },
        components: {
            ValidationProvider,
            ValidationObserver,

            StaffAutoComplete
        },
        watch: {
            formId: {
                immediate: true,
                handler(value) {
                    this.form.car_reservation_id = value;
                }
            },
            'form.status'(val) {
                if (val === 'approved') {
                    this.form.reason = null;
                } else if (val === 'declined') {
                    this.form.deliverer_id = null;
                }
            }
        },
        data() {
            return {
                formLoading: false,
                form: {
                    car_reservation_id: null,
                    status: null,
                    reason: null,
                    deliverer_id: null,
                },
                options: [
                    {value: 'approved', text: this.$t('approved')},
                    {value: 'declined', text: this.$t('declined')},
                ]
            }
        },
        methods: {
            async saveForm() {
                const isValid = await this.$refs.formModalValidate.validate()
                if (isValid) {
                    CarReservationService.approveReservation(this.form)
                                 .then((response) => {
                                     this.$toast.success(this.$t("api." + response.data.message));
                                     this.$emit("approveReservationFormSuccess")
                                 })
                                 .catch((error) => {
                                     this.showErrors(error, this.$refs.formModalValidate)
                                 });
                }
            }
        }
    }
</script>
